import { ComboboxItem } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { userQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);

  if (res.data.length) {
    const newData: ComboboxItem[] = [];

    for (const i in res.data) {
      const { _id, full_name } = res.data[i];

      newData.push({
        label: full_name,
        value: _id,
      });
    }
    // console.log(newData);
    return newData;
  }
  return null;
};

interface Props {
  accountOptions?: boolean;
  role?: string;
  serviceId?: string;
  isEnabled?: boolean;
}
export const useGetDoctorsForConsultationService = ({
  accountOptions = false,
  role,
  serviceId,
  isEnabled = false,
}: Props) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: [...userQKeys.allWithFilters({ role, serviceId }), { accountOptions }],
    queryFn: () => {
      return api.get(accountOptions ? 'user/options' : 'user/users', { params: { role, service: serviceId } });
    },
    select,
    staleTime: Infinity,
    enabled: isEnabled,

    onError: (res: any) => {
      console.error("[From Get All Doctors For Consultation Service]", res);
      handleErrors(res, "query");
    },
  });
};
